import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { MomoSchedule } from '@app/entities/models/mot/schedule/momo-schedule.model';
import { Schedule, ScheduleObservations } from '@app/entities/models/mot/schedule/schedule.model';

export interface ScheduleRepository {
  getSchedule(): Observable<Schedule>;
  getMomoSchedule(): Observable<MomoSchedule>;
  getMonthlyObservations(year: string, month: string): Observable<ScheduleObservations>;
  onError$: Observable<ErrorMsgEnum>;
}

export const SCHEDULE_REPOSITORY = new InjectionToken<ScheduleRepository>('SCHEDULE_REPOSITORY');
